import * as appStorage from './appIndexedDB';

/**
 * PCS domain 判斷（從 Sidebar 搬出來共用）。
 *
 * 第三方服務（Outlook 連結）與「信件即時通知」只開放 JWT `domain === 'PCS'` 的使用者；
 * 後端 `requirePcsDomain` 是最後一道防線，前端用這裡決定入口要不要出現。
 */

export function decodeJwtPayload(token) {
  const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
  const jsonStr = decodeURIComponent(
    atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
  );
  return JSON.parse(jsonStr);
}

function extractTokenString(raw) {
  if (!raw) return null;
  if (typeof raw === 'string') return raw;
  if (typeof raw === 'object')
    return raw.token || raw.accessToken || raw.value || raw.data || null;
  return null;
}

export function isTokenPcsUser(raw) {
  const token = extractTokenString(raw);
  if (!token) return false;
  try {
    return decodeJwtPayload(token)?.domain === 'PCS';
  } catch {
    return false;
  }
}

/** 目前登入者是否為 PCS domain；讀不到 token 時當作不是 */
export function isCurrentUserPcs() {
  try {
    return isTokenPcsUser(appStorage.getItemSync('mygenie_token'));
  } catch {
    return false;
  }
}
